module.exports = __webpack_public_path__ + "static/media/infoTruck.77dcff6e.svg";